var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isLoggedIn,
          expression: "isLoggedIn"
        }
      ]
    },
    [
      _vm.isProcessing
        ? _c("div", { staticClass: "is-processing" }, [_c("CircleLoader")], 1)
        : _c(
            "div",
            {
              staticClass: "vouchers-container",
              class: { no_vouchers: !_vm.vouchers.length }
            },
            [
              !_vm.accountSummaryFlow
                ? _c("h1", [
                    _vm._v(
                      _vm._s(_vm.$t("Promotions.AccountPage.ActiveVouchers"))
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.vouchers
                ? _c("div", [
                    _vm.vouchers.length
                      ? _c(
                          "div",
                          _vm._l(_vm.vouchers, function(
                            voucher,
                            i,
                            expiresSoon,
                            isSOvoucher
                          ) {
                            return _c(
                              "div",
                              {
                                key: i,
                                attrs: {
                                  set: [
                                    (expiresSoon = _vm.expiresIn(
                                      voucher.ExpiryDate
                                    )),
                                    (isSOvoucher = _vm.checkSOvoucher(voucher))
                                  ]
                                }
                              },
                              [
                                _c("div", { staticClass: "voucher-item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "voucher-item__title" },
                                    [_vm._v(_vm._s(voucher.Description))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "voucher-item__content" },
                                    [
                                      _c("div", { staticClass: "dates" }, [
                                        _c(
                                          "div",
                                          { staticClass: "date-start-wrapper" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "date-start" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Promotions.AccountPage.VoucherItem.IssuedOn"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.parseDateTime(
                                                    voucher.TsCreated
                                                  )
                                                )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "date-end-wrapper" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "date-end" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Promotions.AccountPage.VoucherItem.ValidFrom"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.parseDateTime(
                                                    voucher.ValidityStartDate
                                                  )
                                                )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "date-end-wrapper" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "date-end" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Promotions.AccountPage.VoucherItem.ValidUntil"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.parseDate(
                                                    voucher.ExpiryDate
                                                  )
                                                )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        expiresSoon
                                          ? _c(
                                              "div",
                                              { staticClass: "expires-soon" },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Promotions.AccountPage.VoucherItem." +
                                                          (expiresSoon === -1
                                                            ? "Expired"
                                                            : "ExpiresSoon"),
                                                        { inDays: expiresSoon }
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      !isSOvoucher ||
                                      (isSOvoucher && _vm.showSOvoucherAmount)
                                        ? _c(
                                            "span",
                                            { staticClass: "amount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    voucher.CurrentAmount
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "type-description" },
                                    [_vm._v(_vm._s(voucher.TypeDescription))]
                                  ),
                                  _vm._v(" "),
                                  voucher.CustomerNotes
                                    ? _c(
                                        "div",
                                        { staticClass: "customer-notes" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "customer-notes-title"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Promotions.AccountPage.CustomerNotes.Title"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "customer-notes-desc"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(voucher.CustomerNotes)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", [
                          _c(
                            "p",
                            { staticClass: "no-vouchers-found" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { color: "info", size: "18" }
                                },
                                [_vm._v("info")]
                              ),
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Promotions.AccountPage.NoActiveVouchers.Msg"
                                  )
                                )
                              )
                            ],
                            1
                          )
                        ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage
                ? _c("div", { staticClass: "error error-message" }, [
                    _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")
                  ])
                : _vm._e()
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d2b4ef0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d2b4ef0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountVouchers.vue
// module id = null
// module chunks = 